import { useEffect } from "react";
import { useLocation } from "react-router-dom";
var ScrollToTop = function () {
    var _a = useLocation(), pathname = _a.pathname, state = _a.state;
    useEffect(function () {
        if (state === null || state === void 0 ? void 0 : state.preventScrollReset)
            return;
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
export { ScrollToTop };
